import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-field-radiobutton" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", { for: "Python" }, "Python", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { for: "R" }, "R", -1)
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid p-mt-2" }
const _hoisted_5 = { class: "p-field p-col-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "pythonEnvironment",
  class: "kn-material-input-label"
}
const _hoisted_8 = {
  key: 0,
  for: "pythonEnvironment",
  class: "p-error p-mt-2"
}
const _hoisted_9 = { class: "p-field p-col-6" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "dataframeName",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "p-mt-3" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Button = _resolveComponent("Button")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_RadioButton, {
          name: "Python",
          value: "python",
          modelValue: _ctx.dataset.pythonDatasetType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataset.pythonDatasetType = $event)),
          onClick: _ctx.resetPythonEnv
        }, null, 8, ["modelValue", "onClick"]),
        _hoisted_2,
        _createVNode(_component_RadioButton, {
          name: "R",
          class: "p-ml-3",
          value: "r",
          modelValue: _ctx.dataset.pythonDatasetType,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataset.pythonDatasetType = $event)),
          onClick: _ctx.resetPythonEnv
        }, null, 8, ["modelValue", "onClick"]),
        _hoisted_3
      ]),
      _createVNode("form", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_Dropdown, {
              id: "pythonEnvironment",
              class: ["kn-material-input", {
                                'p-invalid': !_ctx.dataset.pythonEnvironment?.label || _ctx.dataset.pythonEnvironment?.label === ''
                            }],
              options: _ctx.datasetTypes,
              optionLabel: "label",
              optionValue: "label",
              modelValue: _ctx.dataset.pythonEnvironment.label,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataset.pythonEnvironment.label = $event)),
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateValueFromLabel(_ctx.datasetTypes, 'value', $event.value)))
            }, null, 8, ["options", "modelValue", "class"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.datasetManagement.environment')) + " * ", 1)
          ]),
          (!_ctx.dataset.pythonEnvironment.label || _ctx.dataset.pythonEnvironment.label === '')
            ? (_openBlock(), _createBlock("small", _hoisted_8, _toDisplayString(_ctx.$t('managers.datasetManagement.envIsRequired')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("span", _hoisted_10, [
            _createVNode(_component_InputText, {
              id: "dataframeName",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.dataframeName.$invalid && _ctx.v$.dataset.dataframeName.$dirty
                            }],
              type: "text",
              modelValue: _ctx.v$.dataset.dataframeName.$model,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.dataset.dataframeName.$model = $event)),
              modelModifiers: { trim: true },
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.dataset.dataframeName.$touch())),
              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('touched')))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.datasetManagement.dataframeName')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.v$.dataset.dataframeName,
            additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.dataframeName') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ])
      ]),
      _createVNode(_component_Button, {
        label: _ctx.$t('managers.datasetManagement.checkEnvironment'),
        class: "p-button kn-button--primary",
        disabled: !_ctx.dataset.pythonEnvironment.label,
        onClick: _ctx.checkEnvironment
      }, null, 8, ["label", "disabled", "onClick"]),
      _createVNode(_component_VCodeMirror, {
        class: "p-mt-4",
        ref: "codeMirrorPython",
        value: _ctx.dataset.pythonScript,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataset.pythonScript = $event)),
        autoHeight: true,
        options: _ctx.scriptOptions,
        onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('touched')))
      }, null, 8, ["value", "options"]),
      _createVNode(_component_Dialog, {
        header: _ctx.$t('managers.datasetManagement.availableLibraries'),
        style: {"width":"60vw"},
        visible: _ctx.libListVisible,
        modal: false,
        class: "p-fluid kn-dialog--toolbar--primary",
        closable: false
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "kn-button kn-button--primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.libListVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_DataTable, {
              class: "p-datatable-sm kn-table",
              value: _ctx.pythonEnvLibs,
              scrollable: true,
              responsiveLayout: "stack",
              breakpoint: "960px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "name",
                  header: _ctx.$t('kpi.alert.name'),
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    (_ctx.dataset.pythonDatasetType == 'python')
                      ? (_openBlock(), _createBlock("span", _hoisted_13))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(data.name) + " ", 1),
                    (_ctx.dataset.pythonDatasetType == 'r')
                      ? (_openBlock(), _createBlock("span", _hoisted_14))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(data[0]), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "version",
                  header: _ctx.$t('common.version'),
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    (_ctx.dataset.pythonDatasetType == 'python')
                      ? (_openBlock(), _createBlock("span", _hoisted_15))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(data.version) + " ", 1),
                    (_ctx.dataset.pythonDatasetType == 'r')
                      ? (_openBlock(), _createBlock("span", _hoisted_16))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(data[1]), 1)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ]),
        _: 1
      }, 8, ["header", "visible"])
    ]),
    _: 1
  }))
}